import './Services.css'

const Services = () => {
    return (
        <div>
            <div className="services" data-aos="fade-up"
                data-aos-duration="1000">
                <h3>AMENITIES AND SERVICES</h3>
                <div className="services-cards">
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/1.jpg" alt="services" />
                        <p>GYM</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/2.jpg" alt="services" />
                        <p>COFFEE SHOP</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/3.jpg" alt="services" />
                        <p>SAUNA</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/4.jpg" alt="services" />
                        <p>24/7 ELECTRICITY</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/5.jpg" alt="services" />
                        <p>PARK ON ALL SIDES</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/6.jpg" alt="services" />
                        <p>SMART ELEVATOR</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/7.jpg" alt="services" />
                        <p>SMART APPARTMENTS</p>
                    </div>
                    <div className="services-card">
                        <img src="./ParkPhotos/Services/8.png" alt="services" />
                        <p>GATED COMMUNITY</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Services